/**
 * CinemaToggleButton — enters cinema mode (hide all UI) from page chrome.
 *
 * Styled with the shared dark-glass toolbar spec so it sits naturally in the 3D
 * views' floating controls. There is no "on" state to render: the moment cinema
 * mode engages, this button is hidden along with everything else, and
 * `CinemaExitButton` takes over.
 */
import { Clapperboard } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useCinemaStore } from '@/stores/cinemaStore'
import { TOOLBAR_BASE, TOOLBAR_OFF } from '@/components/overlay-ui'

interface CinemaToggleButtonProps {
  className?: string
  /** Render icon-only (no label). */
  compact?: boolean
}

export function CinemaToggleButton({ className, compact }: CinemaToggleButtonProps) {
  const enter = useCinemaStore((s) => s.enter)

  return (
    <button
      type="button"
      onClick={() => enter('manual')}
      title="Cinema mode — hide all UI (Ctrl+Shift+H)"
      className={cn(TOOLBAR_BASE, TOOLBAR_OFF, compact && 'w-9 justify-center px-0', className)}
    >
      <Clapperboard className="h-4 w-4" />
      {!compact && 'Cinema'}
    </button>
  )
}
